module.exports = __webpack_public_path__ + "static/media/hat-cowboy-side.96778ac3.svg";